import {Box, Grid, styled} from '@mui/material';
import {CartViolation, CartViolationType} from '../../../api/models';
import {TextComponent} from '../../RetailerWebScreen/components/TextComponent';
import {useEffect, useState} from 'react';
import {useEventBatching} from '../../../api/events';

const StyledBox = styled(Box)<{
    backgroundColor: string;
}>(({backgroundColor}) => ({
    paddingTop: 12,
    paddingBottom: 12,
    paddingLeft: 20,
    paddingRight: 20,
    margin: 0,
    backgroundColor: backgroundColor,
    borderRadius: 8,
}));

export const ViolationItem = ({cartId, violation}: {cartId: string; violation: CartViolation}) => {
    const [violationColor, setViolationColor] = useState('#f7543b');
    const [message, setMessage] = useState("There's something wrong with the cart");

    const {trackEvent} = useEventBatching();

    useEffect(() => {
        trackEvent({
            eventName: 'Cart Violation',
            props: {
                violationType: violation.type,
                cartId: cartId,
            },
        });
        switch (violation.type) {
            case CartViolationType.MISSING_ITEM_IN_CATALOG:
                setMessage('There are some issues with item in catalog.');
                setViolationColor('#6E0101');
                break;
            case CartViolationType.CATALOG_ITEM_INACTIVE:
                setMessage('Item is unavailable, please remove this from cart.');
                setViolationColor('#873901');
                break;
            case CartViolationType.WEBSITE_INACTIVE:
                setMessage('This website is unavailable');
                setViolationColor('#873901');
                break;
            case CartViolationType.WEBSITE_USER_ROLE_INVALID:
                setMessage('Website does not support this action');
                setViolationColor('#6E0101');
                break;
            case CartViolationType.MISSING_PAYMENT_INFORMATION:
                setMessage('Website owner does not have payment receiving information added');
                setViolationColor('#FC0F43');
                break;
        }
    }, [violation]);

    return (
        <Grid item md={12} xs={12} sm={12}>
            <StyledBox backgroundColor={violationColor}>
                <TextComponent variant='caption' content={message} fontWeight={300} color='white' marginBottom={1} />
            </StyledBox>
        </Grid>
    );
};
